import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Provider } from "@aviv-unified-frontend/shell";
import { createMonitoringContext } from "@aviv-unified-frontend/runtime/monitoring";
import { BRAND_CONFIGURATION } from "../configs/brands";
import { registry } from "../configs/registry";
import { AirshipLoader } from "./components/Airship";
import { IS_DEV_LIKE_ENVIRONMENT } from "./constants/environment";
import { Router } from "./components/Router";
import { Layout } from "./components/Layout";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { DevTools } from "./components/DevTools";
import { QualtricsLoader } from "./components/Qualtrics";
import { GlobalStoreProvider, createGlobalStoreContext, } from "./utils/useGlobalStore";
import { useLoadTranslations } from "./utils/useLoadTranslations";
import { createShellLifecycleContext } from "./utils/createShellLifecycleContext";
import { RuntimeApplicationProvider } from "./federation/runtime/useRuntimeApplication";
import { MetaDatas } from "./components/MetaDatas";
import { InitialApplicationScript } from "./federation/InitialApplicationScript";
import { AppBanner } from "./components/AppBanner";
import { useDatadogConsent } from "./utils/consentManagement";
const lifecycleContext = createShellLifecycleContext();
const monitoringContext = createMonitoringContext({
    useConsent: useDatadogConsent,
});
const consentContext = {
    id: BRAND_CONFIGURATION.consentManagement.id,
};
export const Shell = ({ initialApplication, authenticationContext, fetcherContext, headContext, i18nContext, routerContext, headerFooterConfig, applicationId, useEnvironmentContext, }) => {
    return (_jsx(GlobalStoreProvider, { context: createGlobalStoreContext({
            initialApplication,
            headerFooterConfig,
            applicationId,
        }), children: _jsx(ShellProvider, { authenticationContext: authenticationContext, fetcherContext: fetcherContext, headContext: headContext, i18nContext: i18nContext, routerContext: routerContext, useEnvironmentContext: useEnvironmentContext }) }));
};
const ShellProvider = ({ authenticationContext, fetcherContext, headContext, i18nContext, routerContext, useEnvironmentContext, }) => {
    const ConditionalRuntimeProvider = IS_DEV_LIKE_ENVIRONMENT
        ? RuntimeApplicationProvider
        : Fragment;
    const environmentContext = useEnvironmentContext();
    return (_jsx(Provider, { authenticationContext: authenticationContext, brandContext: {
            id: BRAND_CONFIGURATION.id,
            origin: BRAND_CONFIGURATION.origin,
        }, consentContext: consentContext, environmentContext: environmentContext, fetcherContext: fetcherContext, headContext: headContext, i18nContext: i18nContext, lifecycleContext: lifecycleContext, routerContext: routerContext, theme: BRAND_CONFIGURATION.theme, registry: registry, monitoringContext: monitoringContext, featureFlaggingContext: BRAND_CONFIGURATION.featureFlags, children: _jsxs(InitializeShell, { children: [_jsxs(ErrorBoundary, { name: "head", children: [_jsx(MetaDatas, {}), _jsx(InitialApplicationScript, {})] }), _jsxs(ErrorBoundary, { name: "layout", children: [_jsxs(Layout, { children: [_jsx(AppBanner, {}), _jsxs(ConditionalRuntimeProvider, { children: [_jsx(ErrorBoundary, { name: "router", children: _jsx(Router, {}) }), IS_DEV_LIKE_ENVIRONMENT && _jsx(DevTools, {})] })] }), _jsx(QualtricsLoader, {}), _jsx(AirshipLoader, {})] })] }) }));
};
/**
 * Slotted component to load translations.
 * This pattern is used to prevent unnecessary re-renders of the Shell content when translations are loaded, updated...
 */
const InitializeShell = ({ children }) => {
    useLoadTranslations();
    return children;
};
